import { useState, useEffect, useRef } from 'react'
import {
  Text,
  View,
  TouchableOpacity,
  SafeAreaView,
  Platform,
  StyleSheet,
  Alert
} from 'react-native'
import { Camera, CameraType } from 'expo-camera'
import { AntDesign, Ionicons, MaterialCommunityIcons } from '@expo/vector-icons'
import * as ImageManipulator from 'expo-image-manipulator'

// helpers
import { excludeExtensions, getFormData } from '../../helpers/onboardingHelper'

// stores
import { useFormsStore } from '../../stores/onboarding'
import { colorPalette, globalStyles } from '../../static/styles/global'

// constants
import { FILE_EXTENSIONS } from '../../constants/onboardingConstants'

const TakePictureScreen = ({ navigation, route }): JSX.Element => {
  const cameraRef = useRef(null)
  const [hasPermission, setHasPermission] = useState(null)
  const [type, setType] = useState(CameraType.back)

  // params
  const { params } = route
  const {
    description,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey,
    permittedUploadExtensions
  } = params

  console.log('allowedExtensions from camera', permittedUploadExtensions)

  // stores' data
  const { postData } = useFormsStore()

  const handleUploadScannedDocument = async () => {
    // get picture from camera
    const options = {
      quality: 1,
      base64: false,
      exif: false
    }
    const result = await cameraRef.current.takePictureAsync(options)

    // close camera
    navigation.goBack()

    // get image extension only
    const allowedImageExtensions = excludeExtensions(
      permittedUploadExtensions,
      FILE_EXTENSIONS
    )

    // logs
    // console.log('allowedExtensions:', permittedUploadExtensions)
    // console.log('allowedImageExtensions:', allowedImageExtensions)

    try {
      // form data
      const formData = await getFormData(
        result.uri,
        description,
        allowedImageExtensions
      )

      // send document to storage
      postData(essUserOnBoardingKey, essUserOnBoardingFormKey, formData)
    } catch (error) {
      // console.log(error.message)
      Alert.alert('File not supported', error.message)
    }
  }

  useEffect(() => {
    ;(async () => {
      const { status } = await Camera.requestCameraPermissionsAsync()
      setHasPermission(status === 'granted')
    })()
  }, [])

  if (hasPermission === null) {
    return <View />
  }

  if (hasPermission === false) {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <Text>No access to camera</Text>
      </View>
    )
  }

  return (
    <SafeAreaView style={{ flex: 1 }}>
      <Camera style={{ flex: 1 }} type={type} ref={cameraRef}>
        <TouchableOpacity
          style={[styles.closeCamera]}
          onPress={() => navigation.goBack()}
        >
          <AntDesign name="close" size={28} color="white" />
        </TouchableOpacity>
        <View style={[styles.cameraActions]}>
          {false && (
            <TouchableOpacity
              style={[styles.flipCamera]}
              onPress={() => {
                setType(
                  type === CameraType.back ? CameraType.front : CameraType.back
                )
              }}
            >
              <View style={[globalStyles.hDirection]}>
                <MaterialCommunityIcons
                  name="camera-flip-outline"
                  size={26}
                  color={colorPalette.white}
                  style={[globalStyles.mr1, globalStyles.tn2]}
                />
                <Text style={[styles.flipCameraText]}>Flip Camera</Text>
              </View>
            </TouchableOpacity>
          )}
          <TouchableOpacity
            style={[styles.takePicture]}
            onPress={handleUploadScannedDocument}
          >
            <View style={[globalStyles.hDirection]}>
              {/* <MaterialCommunityIcons
                name="camera-outline"
                size={26}
                color={colorPalette.white}
                style={[globalStyles.mr1, globalStyles.tn1]}
              /> */}
              <Ionicons
                name={'camera-outline'}
                size={26}
                color={colorPalette.white}
                style={[globalStyles.mr1, globalStyles.tn2]}
              />
              <Text style={[styles.takeCameraText]}>Take Picture</Text>
            </View>
          </TouchableOpacity>
        </View>
      </Camera>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  cameraActions: {
    flex: 1,
    backgroundColor: 'transparent',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  flipCamera: {
    flex: 1,
    alignSelf: 'flex-end',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 153, 229, .8)',
    paddingTop: 15,
    paddingBottom: 5,
    borderRightWidth: 1,
    borderColor: 'rgba(255, 255, 255, .2)'
  },
  flipCameraText: {
    fontSize: 18,
    marginBottom: 10,
    color: 'white'
  },
  takePicture: {
    flex: 1,
    alignSelf: 'flex-end',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 153, 229, .8)',
    paddingTop: 15,
    paddingBottom: 5
  },
  takeCameraText: {
    fontSize: 18,
    marginBottom: 10,
    color: 'white'
  },
  closeCamera: {
    alignSelf: 'flex-end',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 153, 229, .8)',
    paddingHorizontal: 10,
    paddingVertical: 10,
    marginVertical: 40
  }
})

export default TakePictureScreen
